import api from '../../plugins/api';

const getDealEquipments = (params) => {
  return api.get('/api/crm/deals/getDealEquipments', params);
};

export default getDealEquipments;
